import shortlisted from './shortlisted-notice';
import deal from './deal-notice';
export default {
    path: 'frame-agreement',
    component: () => import(/*webpackChunkName: 'bidding-dingbiao'*/ '@layout/empty'),
    children: [
        shortlisted,
        deal,
    ]
}